export default __webpack_public_path__ + "static/how-it-works-phase-2-mobile-c0b7e60b29f2a0e4ab67c908f21d1f2d.svg";